/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ open: NonNullable<unknown> }} Workout_Live_Forgotten_Lead_EmptyInputs */

const en_us2_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This workout has been open for ${i?.open}, with no sets logged.`)
};

const pt_br2_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse treino está aberto há ${i?.open}, sem nenhuma série registrada.`)
};

const es_419_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este entrenamiento lleva ${i?.open} abierto, sin ninguna serie registrada.`)
};

const pt_pt2_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este treino está aberto há ${i?.open}, sem nenhuma série registada.`)
};

const fr_fr2_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette séance est ouverte depuis ${i?.open}, sans aucune série enregistrée.`)
};

const de_de2_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Training ist seit ${i?.open} offen, ohne erfassten Satz.`)
};

const it_it2_workout_live_forgotten_lead_empty = /** @type {(inputs: Workout_Live_Forgotten_Lead_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo allenamento è aperto da ${i?.open}, senza nessuna serie registrata.`)
};

/**
* | output |
* | --- |
* | "This workout has been open for {open}, with no sets logged." |
*
* @param {Workout_Live_Forgotten_Lead_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_lead_empty = /** @type {((inputs: Workout_Live_Forgotten_Lead_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_Lead_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_lead_empty(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_lead_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_lead_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_lead_empty(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_lead_empty(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_lead_empty(inputs)
	return en_us2_workout_live_forgotten_lead_empty(inputs)
});
export { workout_live_forgotten_lead_empty as "workout-live.forgotten_lead_empty" }